const server = {
  local: {
    admin: '//jpjs.geeker.com.cn/'
    //admin: '//172.16.12.34:8080/scenic/'
    //admin: '//172.16.12.25:8091/'
  },
  dev: {
    admin: '//jpjs.geeker.com.cn/'
     //admin: '//192.168.1.10:8085/'
     //admin: '//192.168.1.9:8085/'
    //admin: '//192.168.16.10:10125/'
  },
  pro: {
    admin: '//jpjs.geeker.com.cn/'
    //admin: '//jpjs.geeker.com.cn/'
  }
}
export default server



// WEBPACK FOOTER //
// ./src/config/server.js